<template>
  <div class="Home">
    <div class="bg">
      <img
        src="https://picbed.qunarzz.com/c8099ba91fa9e804e5ebefddfff26ee2.png"
        alt=""
      />
      <div @click="showRule" class="rule"></div>
      <div @click="showAward" class="award"></div>
      <div @click="startAnswer" class="startAnswer">
        <span class="label">开始挑战</span>
      </div>
    </div>
  </div>
</template>

<script>
// import award from "./dialog/award/index";
// import ruleDialog from "./dialog/rule/index";
export default {
  methods: {
    startAnswer() {
      this.$emit("startAnswer");
    },
    showRule() {
      //ruleDialog();
    },
    showAward() {
      //award();
    },
  },
};
</script>

<style lang="less" scoped="true">
.bg {
  position: relative;
}
.startAnswer {
  width: 179px;
  height: 53px;
  font-size: 25px;
  text-align: center;
  line-height: 53px;
  background: url(https://picbed.qunarzz.com/635c01bb3054e6eb7241ac1c357d5c12.png) no-repeat;
  background-size: 100% auto;
  border-radius: 7px;
  position: absolute;
  left: 50%;
  margin-left: -90px;
  top: 524px;
  font-weight: normal;
  color: #fff;
  line-height: 31px;
  display: flex;
  align-items: center;
  justify-content: center;
  .label{
    text-shadow: 2px 0 0 #000,-2px 0 0 #000,0 -2px 0 #000,0 2px 0 #000;
    position: relative;
    font-weight: bold;
    top:-2px;
  }
}
.danmu {
  position: absolute;
  left: 50%;
  margin-left: -75px;
  top: 305px;
}
.award {
  position: absolute;
  left: 12px;
  top: 420px;
  width: 40px;
  height: 138px;
}
.rule {
  position: absolute;
  right: 5px;
  top: 264px;
  width: 76px;
  height: 120px;
  background:url(https://picbed.qunarzz.com/c52008e4ef7b455132d70f17dd1a25ac.png) no-repeat;
  background-size: 100% auto;
}
</style>